export const appendToArray = (array, object) => {
    return [...array, object];
}

export const removeFromArray = (array, object) => {
    return array.filter(item => item !== object);
}

export const removeFromArrayByIndex = (array, index) => {
    return array.filter((_, i) => i !== index);
}

export const updateArrayItem = (array, index, object) => {
    return array.map((item, i) => i === index ? object : item);
}

export const updateArrayItemByKey = (array, key, value, object) => {
    return array.map(item => item[key] === value ? object : item);
}

export const findArrayItemByKey = (array, key, value) => {
    return array.find(item => item[key] === value);
}

export const findArrayItemByIndex = (array, index) => {
    return array[index];
}

export const findArrayItemByValue = (array, value) => {
    return array.find(item => item === value);
}

export const findAndRemoveFromArray = (array, id) => {
    const clone = JSON.parse(JSON.stringify(array));
    const found = clone.find((object) => id === object.id);

    if (found !== undefined && found !== null) {
        clone.splice(clone.indexOf(found), 1);
    }

    return clone;
}

export const findAndReplaceInArray = (array, data, id) => {
    const clone = JSON.parse(JSON.stringify(array));
    const found = clone.find((object) => id === object.id);

    if (found !== undefined && found !== null) {
        clone[clone.indexOf(found)] = data;
    } else {
        clone.push(data);
    }

    return clone;
}